Wee.fn.make('search', {
	init: function() {
		var priv = this.$private;

		priv.initSearch();
	}
}, {

	/**
	 * Search
	 *
	 * @private
	 */
	initSearch: function() {
		var scope = this,
			$searchLabel = $('ref:searchLabel');

		$.events.on({
			'ref:search': {
				'click': function() {
					scope.toggleSearch();
				}
			},
			'ref:searchClose': {
				'click': function() {
					scope.toggleSearch();
				}
			},
			'ref:searchField': {
				'keydown': function() {
					$searchLabel.hide();
				},
				'blur': function() {
					if ($('ref:searchField').val() === '') {
						$searchLabel.show();
					}
				}
			}
		}, {
			namespace: 'search'
		});
	},

	/**
	 * Toggle search
	 *
	 * @private
	 */
	toggleSearch: function() {
		var $mobileMenu = $('ref:mobileMenu');

		$('ref:body').toggleClass('-search-active');

		$.screen.map({
			max: 3,
			callback: function() {
				$('ref:header').toggleClass('-is-active');

				$mobileMenu.isActive() ? $mobileMenu.deactivate() : $mobileMenu.activate();
			}
		});

		if ($('ref:weeTopAlert').isDisabled()) {
			$('ref:searchForm').css('top', 0);
		}

		$('ref:searchField').val('')[0].focus();
	}
});